import axios from "axios";
import {baseAddress} from "../../../tools/baseAddress"

let addressGetAllSystems = baseAddress + "api/systems/";  
let addressSystemChangeEnabled = baseAddress + "api/systems/toggle-enabled";  
let addressDeleteSystem = baseAddress + "api/systems/delete";  
let addressAddSystem = baseAddress + "api/systems/add";  
let addressEditSystem = baseAddress + "api/systems/edit";  
let addressSystemInfo = baseAddress + "api/systems/"; 

export const getAllSystems = () => {
  return axios
    .get(addressGetAllSystems, {
      params: {
        token: localStorage.getItem("token")
      }
    })
    .then(response => {
      return response
    })
    .catch(err => {
      console.error(err)
    })
}

export const systemChangeEnabled = (info_json) => {
  return axios
    .post(addressSystemChangeEnabled,
      {
        token: localStorage.getItem("token"),
        info: info_json,
      })
    .then(response => {
      return response
    })
    .catch(err => {
      console.error(err)
    })
}

export const deleteSystem = (systemName) => {
  return axios
    .post(addressDeleteSystem,
      {
        token: localStorage.getItem("token"),
        system_key: systemName
      })
    .then(response => {
      return response
    })
    .catch(err => {
      return err.response
    })
}

export const addSystem = (formData) => {
  return axios
    .post(addressAddSystem, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: {
        token: localStorage.getItem("token")
      }
    })
    .then(response => {
      return response
    })
    .catch(err => {
      return err.response
    })
}

export const editSystem = (formData) => {
  return axios
    .post(addressEditSystem, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      params: {
        token: localStorage.getItem("token")
      }
    })
    .then(response => {
      return response
    })
    .catch(err => {
      return err.response
    })
}

export const getSystemInfo = (systemName) => {
  return axios
    .get(addressSystemInfo + systemName + '/info', {
      params: {
        token: localStorage.getItem("token")
      }
    })
    .then(response => {
      return response
    })
    .catch(err => {
      console.error(err)
    })
}

export const dataDashboard = async () => await axios.post(baseAddress + 'api/dashboard', {
  token: localStorage.getItem("token")
});